import { useScreenSize } from 'utils/useScreenSize'

type TitleChildrenWrapperProps = {
  children: React.ReactNode
  wideScreenGap?: string
}

export const TitleChildrenWrapper = ({ children, wideScreenGap }: TitleChildrenWrapperProps) => {
  const { isWideScreen } = useScreenSize()

  const wideScreenStyles = {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    gap: wideScreenGap || '16px',
    marginRight: '5px',
  }

  const narrowScreenStyles = {
    display: 'flex',
    flex: 1,
    gap: '16px',
  }

  return <div css={isWideScreen ? wideScreenStyles : narrowScreenStyles}>{children}</div>
}
